export default __webpack_public_path__ + "static/media/notFound.34584723.gif";